/** @format */

import { defineStore } from 'pinia';
import { store } from '@/store';
import { queryNotReadMsgList, getNoticeOrMsgList, getUnReadMsgCount } from '@/api/message/index';

interface MessageState {
	msgHeaderInfo: {
		list: any[];
		count: number;
	};
	messageHomeInfo: {
		list: any[];
		count: number;
		pageValue: {
			pageNum: number;
			pageSize: number;
		};
		sysStatus: string;
		hasDataMore: boolean;
	};
}

export const useMessageStore: any = defineStore('msg', {
	state: (): MessageState => ({
		// 公共头部消息状态
		msgHeaderInfo: {
			list: [],
			count: 0,
		},
		// 首页消息通知状态
		messageHomeInfo: {
			list: [],
			count: 0,
			pageValue: {
				pageNum: 1,
				pageSize: 10,
			},
			sysStatus: '', // '':全部，notice:公告，message:未读消息
			hasDataMore: true,
		},
	}),
	actions: {
		// 更新头部消息数据
		updateMsgHeaderData() {
			this.fetchMsgHeaderData();
		},
		// 更新首页消息通知列表
		updateHomeMsgList(params, isEmptyList = true) {
			this.fetchHomeMsgListData(params, isEmptyList);
		},
		// 更新首页消息总数
		updateHomeMsgCount() {
			this.fetchMsgHomeCountData();
		},
		// 消息通知tab
		updateMsgHomeClickTab(val: '' | 'notice' | 'msg') {
			this.messageHomeInfo.sysStatus = val;
		},

		async fetchMsgHeaderData() {
			try {
				const data: any = await queryNotReadMsgList();
				this.msgHeaderInfo.count = data.total;
				this.msgHeaderInfo.list = data.rows;
				return true;
			} catch (error) {
				return false;
			}
		},

		async fetchMsgHomeCountData() {
			this.messageHomeInfo.list = [];
			try {
				const res: any = await getUnReadMsgCount({});
				this.messageHomeInfo.count = res.unReadMsgCount;
				return true;
			} catch (error) {
				return false;
			}
		},

		getWeekday(dateString) {
			const date = new Date(dateString);
			const weekday = date.getDay();
			const weekdays = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
			return weekdays[weekday];
		},

		async fetchHomeMsgListData(params, isEmptyList) {
			if (isEmptyList) {
				// 当点击切换tab时，每次关闭消息列表时、清空列表数据，并重置翻页
				params = this.messageHomeInfo.pageValue;
				this.messageHomeInfo.list = [];
			}
			try {
				const res: any = await getNoticeOrMsgList({
					type: this.messageHomeInfo.sysStatus,
					...params,
				});
				this.messageHomeInfo.pageValue.pageSize = params.pageSize;
				if (res?.page?.currentPageSize < this.messageHomeInfo.pageValue.pageSize) {
					this.messageHomeInfo.hasDataMore = false;
				} else {
					this.messageHomeInfo.hasDataMore = true;
				}
				const arrData = (res.pageData || []).reduce((arr: any, it): any => {
					arr.push({
						time: `${it.time} ${this.getWeekday(it.time)}`,
						timeLine: it.timeLine,
					});
					return arr;
				}, []);
				this.messageHomeInfo.list = this.messageHomeInfo.list.concat(arrData);
				return true;
			} catch (error) {
				return false;
			}
		},
	},
});

export function useMessageStoreWithOut(): any {
	return useMessageStore(store);
}
